<template>
    <div class="pass_banner">
        <div id="certify">
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item, index) in passList" :key="index">
                        <div class="pass_item">
                            <img class="pass_img" :src="item.imgUrl" alt="">
                            <div class="pass_contain">
                                <div class="name">{{ item.name }}</div>
                                <div class="desc" v-html="item.desc"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
        </div>
    </div>
</template>

<script>
import Swiper from "swiper"
import "swiper/css/swiper.css";

export default {
    name: '',
    data() {
        return {
            passList: [
                {
                    imgUrl: require('@/assets/newhome/pass/pass_物联网.png'),
                    name: "物联网接入平台",
                    desc: `<p>平台是一个集成了设备管理、数据安全通信和消息订阅等能力的一体化平台。向下支持连接海量设备，采集设备数据上云；向上提供API，服务端可通过调用API将指令下发至设备端，实现远程控制；通过物联网连接平台将各类设备数据采集、传输的开发过程进行可视化的方式实现，大大提高了设备物联网连接的效率；从各类设备数据采集方面，降低了对开发人员的依赖性，简单培训过后即可上手操作，实现对各种设备的数据采集，降低人员成本费用；且项目实施周期减少，效率更高，从而降低了项目成本。主要提供设备接入、设备管理、规则引擎等能力，为各类IoT场景和行业开发者赋能。设备接入物联网平台后，可上报设备数据至IoT接入平台。物联网平台实现设备数据的采集、流转、存储、分析和实时监控的同时，提供安全认证和权限策略服务，保障设备和云端数据的安全。</p>`
                },
                {
                    imgUrl: require('@/assets/newhome/pass/pass_大数据.png'),
                    name: "大数据平台",
                    desc: `<p>大数据平台是一个全面的信息处理和分析系统，它能处理和分析海量、多样性的数据，从而为企业提供决策支持。大数据平台通常包括数据采集、数据存储、数据处理和数据分析等模块。这种平台的使用，帮助企业从大数据中获取价值，提升业务效率，优化决策过程。数据采集是大数据平台的首要环节，包括从各种数据源（如数据库、日志文件、社交媒体、传感器等）获取数据。这些数据可能是结构化的、半结构化的或非结构化的。对于海量的数据，传统的数据库已经无法满足存储和处理的需求。大数据平台通常会采用分布式文件系统（如Hadoop的HDFS）或者NoSQL数据库（如HBase、Cassandra）等进行数据的存储。</p>`
                },
                {
                    imgUrl: require('@/assets/newhome/pass/pass_微服务.png'),
                    name: "微服务管理平台",
                    desc: `<p>微服务平台是一种构建软件系统的基础架构，它将整个软件系统拆解成一系列相对独立的、基于服务的组件，而组件之间通过传统方式或容器技术如Docker互相通信，以达到全面解耦、可重用以及高可靠性的目的。微服务平台根据微服务的特点，采用技术设计来实现可靠的大规模系统的部署和管理，主要包括：微服务容器、服务发现和负载均衡、服务网关、配置中心、容器集群与编排、服务安全、监控和监看、服务调度。微服务平台的优势非常明显，它能有效提升系统的技术可拓展性，减少服务耦合性，优化软件开发生命周期，缩短交付时间，提高开发团队的可维护性，从而让软件系统响应速度更迅速，可用性更强。另外，微服务平台也能够为软件企业提供核心的企业竞争力，提升企业的开发效率，缩短服务交付周期，并加强企业信息系统的安全性。</p>`
                },
                {
                    imgUrl: require('@/assets/newhome/pass/pass_低代码.png'),
                    name: "低代码平台",
                    desc: `<p>低代码平台是无需编码或通过少量代码就可以快速生成应用程序的开发平台。低代码平台通过可视化进行应用程序开发的方法，使具有不同经验水平的开发人员可以通过图形化的用户界面，使用拖拽组件和模型驱动的逻辑来创建网页和移动应用程序。</p>`
                },
                {
                    imgUrl: require('@/assets/newhome/pass/pass_数据接入.png'),
                    name: "数据接入平台",
                    desc: `<p>是云上SAAS化的数据接入和处理平台，协助客户方便快捷地完成一站式的数据接入，处理和分发，平台提供基于 HTTP/TCP 协议的 SDK 协助客户快速完成数据上报、基于 CDC (Change DataCapture)机制快速订阅、存储多款数据库(MySQL、PostgreSQL、MongoDB 等)变更信息，打通了多款云产品的日志投递，并提供简单可配置的数据清洗ETL)能力，以及丰富的数据流出渠道，协助客户低成本搭建教流转链路，构建数据源和数据外理系统间的桥梁。</p>`
                },
                {
                    imgUrl: require('@/assets/newhome/pass/pass_服务管理.png'),
                    name: "服务管理平台",
                    desc: `<p>服务管理平台是一个开发者使用的平台,它能够通过可视化配置,自动生成接口服务,同时为了安全性和差异化服务,加入了接口权限控制功能,同时一键发布到数据汇总平台,并查看相关帮助文档,接口参数等信息。最后全程监控服务调用过程,记录相关日志服务信息,确保系统稳定,排查系统异常,同时提供相关接口调用统计分析数据。</p>`
                },
            ],
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.initPassSwiper()
        })
    },
    methods: {
        initPassSwiper() {
            let swiper = new Swiper('#certify .swiper-container', {
                watchSlidesProgress: true,
                slidesPerView: 'auto',
                centeredSlides: true,  //居中幻灯片。设定为true时，当前的active slide 会居中，而不是默认状态下的居左。
                loop: true,
                loopedSlides: 8,
                autoplay: true,
                speed: 600,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                on: {
                    progress: function (progress) {
                        for (var i = 0; i < this.slides.length; i++) {
                            var slide = this.slides.eq(i);
                            var slideProgress = this.slides[i].progress;
                            var modify = 1;
                            if (Math.abs(slideProgress) > 1) {
                                modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
                            }
                            // var translate = slideProgress * modify * 260 + 'px';
                            var translate = slideProgress * modify * 450 + 'px';
                            // var scale = 1 - Math.abs(slideProgress) / 5;
                            var scale = 1 - Math.abs(slideProgress) / 3.56;
                            var zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
                            slide.transform('translateX(' + translate + ') scale(' + scale + ')');
                            slide.css('zIndex', zIndex);
                            slide.css('opacity', 1);
                            if (Math.abs(slideProgress) > 3) {
                                slide.css('opacity', 0);
                            }
                        }
                    },
                    setTransition: function (transition) {
                        for (var i = 0; i < this.slides.length; i++) {
                            var slide = this.slides.eq(i)
                            slide.transition(transition);
                        }

                    }
                }

            })
        }
    }
}
</script>

<style lang="less" scoped>
body {
    @media screen and (min-width : 1350px) {
        .pass_banner {
            width: 1340px;
            margin-left: -60px;
        }

        #certify {
            width: 1340px;
        }
    }

    @media screen and (max-width:1349px) {
        .pass_banner {
            width: 1220px;
        }

        #certify {
            width: 1220px;
        }
    }
}



#certify {
    position: relative;
    // width: 1220px;

    .swiper-container {
        padding: 30px 0 60px;
    } 

    .swiper-slide {
        width: 780px;
        height: 390px;
        background-color: #ffffff;
        box-shadow: 0px 6px 36px 4px rgba(240, 241, 245, 0.64);
        opacity: 0 !important;
    }

    // .swiper-slide-next {
    //     transform: translateX(-470px) scale(0.719101) !important;
    // }

    .swiper-slide-next,
    .swiper-slide-prev {
        opacity: 0.6 !important;
    }

    .swiper-slide-active {
        opacity: 1 !important;
    }

    .swiper-button-prev,
    .swiper-button-next {
        width: 40px !important;
        height: 40px !important;
        background-color: #cccccc;
        // background-color: rgba(31, 45, 61, .11);
        border-radius: 50%;
        color: #ffffff;

        &::after {
            font-size: 24px !important;
        }

        &:hover {
            // background-color: rgba(31, 45, 61, .23);
            background-color: #0055ff;
        }
    }

    .swiper-button-prev {
        left: 0px !important;
    }

    .swiper-button-next {
        right: 0px !important;
    }

}

.pass_item {
    display: flex;
    background-color: #ffffff;
    width: 100%;
    height: 100%;
    // box-shadow: 0px 6px 36px 4px rgba(240, 241, 245, 0.64);

    .pass_contain {
        padding: 50px 41px 48px;

        &>* {
            position: relative;
            z-index: 5;
        }

        &::before {
            content: "";
            width: 78px;
            height: 78px;
            position: absolute;
            background: url('../../assets/newhome/pass_ball.png') center center no-repeat;
            top: 58px;
            right: 53px;
            z-index: 1;
        }

        .name {
            font-size: 20px;
            color: #222222;
            line-height: 20px;
            margin-bottom: 20px;
        }

        /deep/ .desc {
            p {
                font-size: 14px;
                color: #555555;
                line-height: 23px;
                margin-bottom: 4px;
            }
        }

    }

}
</style>